import React from 'react';

const FeaturesHero: React.FC = () => {
    return (
        <section className="relative px-4 pt-8 pb-4 sm:pt-10 sm:pb-6">
            <div className="container mx-auto max-w-[1640px] relative">
                {/* Main Title */}
                <h1
                    className="text-center mb-2"
                    style={{
                        fontFamily: 'Manrope',
                        fontStyle: 'normal',
                        fontWeight: 700,
                        fontSize: 'clamp(32px, 8vw, 112px)',
                        lineHeight: '1.3',
                        letterSpacing: '-0.05em',
                        color: '#FFFFFF',
                        maxWidth: '90%',
                        margin: '0 auto 0px',
                    }}
                >
                    Redefining the future of recruiting
                </h1>

                {/* Subtitle */}
                <p
                    className="text-center"
                    style={{
                        fontFamily: 'Manrope',
                        fontStyle: 'normal',
                        fontWeight: 200,
                        fontSize: 'clamp(14px, 2vw, 28px)',
                        lineHeight: '1.4',
                        letterSpacing: '-0.02em',
                        color: '#FFFFFF',
                        maxWidth: '100%',
                        margin: '0 auto clamp(20px, 4vw, 40px)',
                    }}
                >
                    From AI-powered matching to seamless pipelines, Hush makes hiring effortless
                </p>

                {/* Large Glassmorphic Card/Video Placeholder */}
                <div
                    style={{
                        width: '100%',
                        maxWidth: '1200px',
                        aspectRatio: '1200 / 600',
                        margin: '0 auto',
                        background: 'transparent',
                        border: '0.75px solid rgba(255, 255, 255, 0.5)',
                        boxShadow: '0px 3.75px 7.5px rgba(0, 0, 0, 0.05), 0px 11.25px 22.5px rgba(0, 0, 0, 0.05), 0px 22.5px 45px rgba(0, 0, 0, 0.1), inset 0px 37.5px 75px rgba(255, 255, 255, 0.15)',
                        backdropFilter: 'blur(7.5px)',
                        borderRadius: '22.5px',
                    }}
                />
            </div>
        </section>
    );
};

export default FeaturesHero;
